module.exports = __webpack_public_path__ + "eeef51575d7113fcec58089f465c817d.svg";